import type { Member, MemberPublic } from '@/lib/db/types';
import { StorageImage } from '@/components/shared/StorageImage';

interface Props {
  member: Member | MemberPublic | { name: string; avatar?: string | null; profile_photo_url?: string | null };
  size?: number;
}

const GOLF_HUES = ['#1e3a5f', '#2d5a3d', '#5a3b1f', '#4a3728', '#3d2b1f', '#1a4a6f', '#2f4f2f', '#4b3621'];
const CARTOON_BG = ['#c4a662', '#397c52', '#6f4e2c', '#0a1e3f', '#8b4513', '#2e8b57'];
const SERVICE_BG = ['#0a1e3f', '#1a3a5c', '#2c4a6e', '#3d5a80'];

export function Avatar({ member, size = 36 }: Props) {
  const initial = member.name?.slice(0, 1).toUpperCase() || '?';
  const avatar = 'avatar' in member ? member.avatar : null;
  const photoUrl = 'profile_photo_url' in member ? member.profile_photo_url : null;

  const style = { width: size, height: size, fontSize: size * 0.38 };

  if (photoUrl) {
    return <StorageImage src={photoUrl} alt="" className="shrink-0 rounded-full object-cover shadow-sm" style={style} />;
  }

  if (avatar?.startsWith('photo:') || avatar?.startsWith('aigen:')) {
    const src = avatar.includes('data:') ? avatar.split(':').slice(1).join(':') : avatar;
    return <img src={src.startsWith('data') ? src : avatar} alt="" className="shrink-0 rounded-full object-cover shadow-sm" style={style} />;
  }

  if (avatar?.startsWith('golf:')) {
    const idx = parseInt(avatar.slice(5), 10) - 1;
    return (
      <div className="flex shrink-0 items-center justify-center rounded-full font-bold text-white shadow-sm" style={{ ...style, background: GOLF_HUES[idx % GOLF_HUES.length] || '#1e3a5f' }}>
        {initial}
      </div>
    );
  }

  if (avatar?.startsWith('cartoon:')) {
    const idx = parseInt(avatar.slice(8), 10) - 1;
    return (
      <div className="flex shrink-0 items-center justify-center rounded-full font-bold text-navy shadow-sm" style={{ ...style, background: CARTOON_BG[idx % CARTOON_BG.length] || '#c4a662' }}>
        {initial}
      </div>
    );
  }

  if (avatar?.startsWith('service:')) {
    const idx = parseInt(avatar.slice(8), 10) - 1;
    return (
      <div className="flex shrink-0 items-center justify-center rounded-full font-bold text-gold shadow-sm" style={{ ...style, background: SERVICE_BG[idx % SERVICE_BG.length] || '#0a1e3f' }}>
        ⭐
      </div>
    );
  }

  return (
    <div className="flex shrink-0 items-center justify-center rounded-full bg-navy/10 font-bold text-navy shadow-sm" style={style}>
      {initial}
    </div>
  );
}
